// components/SEO.jsx
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://kinewsstudiolimited.co.uk";
const DEFAULT_IMAGE = `${SITE_URL}/kinews-logo.jpg`;

export default function SEO({
  title,
  description,
  image = DEFAULT_IMAGE,
  noindex = false,
  jsonLd,
}) {
  const path =
    typeof window !== "undefined" ? window.location.pathname : "/";
  const canonical = `${SITE_URL}${path === "/" ? "/" : path.replace(/\/$/, "")}`;

  return (
    <Helmet>
      {/* Basic */}
      <title>{title}</title>
      {description && <meta name="description" content={description} />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Kinews Studio Limited" />
      <meta property="og:locale" content="en_GB" />
      <meta property="og:title" content={title} />
      {description && (
        <meta property="og:description" content={description} />
      )}
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && (
        <meta name="twitter:description" content={description} />
      )}
      <meta name="twitter:image" content={image} />

      {/* Canonical */}
      <link rel="canonical" href={canonical} />

      <meta
        name="robots"
        content={noindex ? "noindex, nofollow" : "index, follow"}
      />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
